// Modules
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import cx from 'classnames';
import browserHistory from 'react-router/lib/browserHistory';
import { getLang } from 'redux-pagan';
import { connect } from 'react-redux';
// Components
import OMTabs from '../../components/OMComponents/OMTabs/OMTabs';
import OMTab from '../../components/OMComponents/OMTabs/OMTab';
import OMTitle from '../../components/OMComponents/OMTitle/OMTitle';
// Helpers
import appendLocale from '../../helpers/appendLocale';
import { shareUrl, privacyTermsTabs } from '../../constants';
import multiLanguageTags from '../../helpers/multiLanguageHeadTags';
import renderConfig from './renderConfig';
import withPageWrapper from '../../containers/PageContainer/PageContainer';
// Styles
import * as styles from '../PrivacyPolicyPage/PrivacyPolicyPage.scss';

class TermsOfUsePage extends Component {
  componentDidMount() {
    this.parenthesis.innerHTML = this.props.translate('parenthesis');
  }

  handleSelect = (key) => {
    if (key === privacyTermsTabs.PRIVACY) {
      browserHistory.push(appendLocale(this.props.locale, `/privacy${this.props.isNative ? '?native=true' : ''}`));
    }
  };

  renderSubItem = (translationTemplate, key) => (
    <li
      key={key}
      dangerouslySetInnerHTML={{ __html: translationTemplate }}
    />
  );

  renderItem = (itemId, subItemsCount = 0, subSubItems, primary) => {
    const subItems = [];

    for (let idx = 1; idx <= subItemsCount; idx += 1) {
      const key = `${itemId}.${idx}`;
      let subItem = {};

      if (subSubItems && subSubItems.count && subSubItems.forSubItem === idx) {
        subItem = this.renderItem(key, subSubItems.count, subSubItems);
      } else {
        subItem = this.renderSubItem(this.props.translate(key), key);
      }

      subItems.push(subItem);
    }

    return (
      <li key={itemId}>
        {(primary)
          ? (<strong dangerouslySetInnerHTML={{ __html: this.props.translate(itemId) }} />)
          : (<span dangerouslySetInnerHTML={{ __html: this.props.translate(itemId) }} />)
        }
        <ol>
          {subItems}
        </ol>
      </li>
    );
  };

  renderContent = () => renderConfig.map(item =>
    this.renderItem(item.itemId, item.subItems.count, item.subItems.subSubItems, true));

  render() {
    const { route, locale } = this.props;
    const multiLanguage = multiLanguageTags(route, locale);

    return (
      <div className={cx(styles.main_block, 'pageHeight')}>
        <div className={cx(styles.content, styles.onlyHe)}>
          <Helmet
            titleTemplate={this.props.staticTranslates('title', 'titleTemplate')()}
            title={this.props.staticTranslates('title', 'terms')()}
            meta={[
              { property: 'og:url', content: `${shareUrl}${route}` },
              {
                property: 'og:title',
                content: `${this.props.staticTranslates('footer', 'terms')} | \u202BOnMap`
              },
              { property: 'og:description', content: this.props.staticTranslates('helmet', 'termsDescription') },
              { name: 'description', content: this.props.staticTranslates('helmet', 'termsDescription') },
              {
                property: 'x:title',
                content: `${this.props.staticTranslates('footer', 'terms')} | \u202BOnMap`
              },
              { property: 'x:description', content: this.props.staticTranslates('helmet', 'termsDescription') },
              { property: 'x:image:alt', content: this.props.staticTranslates('footer', 'terms') }
            ]}
            link={[
              ...multiLanguage,
              { rel: 'canonical', href: `${shareUrl}${route}` }
            ]}
          />

          <OMTabs
            defaultActiveTabKey={privacyTermsTabs.TERMS}
            onSelect={this.handleSelect}
            id="terms-of-use"
            className="PrivacyTermsTabs"
          >
            <OMTab id={privacyTermsTabs.TERMS} title={`${this.props.staticTranslates('footer', 'terms')}`} >
              {(!this.props.isMobile && !this.props.isNative) && (
                <OMTitle className="pageTitle" title={this.props.staticTranslates('footer', 'terms')} />
              )}
              <p style={{ textAlign: 'right', direction: 'rtl' }} ref={(parenthesis) => { this.parenthesis = parenthesis; }} />
              <ol style={{ direction: 'rtl' }}>
                {this.renderContent()}
              </ol>
            </OMTab>
            <OMTab id={privacyTermsTabs.PRIVACY} title={`${this.props.staticTranslates('footer', 'privacy')}`} />
          </OMTabs>
        </div>
      </div>
    );
  }
}

TermsOfUsePage.propTypes = {
  locale: PropTypes.string.isRequired,
  translate: PropTypes.func.isRequired,
  staticTranslates: PropTypes.func.isRequired,
  route: PropTypes.string.isRequired,
  isMobile: PropTypes.bool,
  isNative: PropTypes.bool
};

const mapStateToProps = state => ({
  translate: getLang(state.lang, 'terms'),
  staticTranslates: getLang(state.lang, 'static')
});

export default connect(mapStateToProps)(
  withPageWrapper(TermsOfUsePage)
);
